/* tslint:disable */
/* eslint-disable */
/* @relayHash 5df966c48815bdb4d079adfcf1badb94 */

import { ConcreteRequest } from "relay-runtime";
export type userGeoInfoQueryVariables = {
    cookieDomain?: string | null;
};
export type userGeoInfoQueryResponse = {
    readonly viewer: {
        readonly regionalInfo: ReadonlyArray<{
            readonly countryCode: string | null;
            readonly zipCode: string | null;
            readonly regionsByZipCode: ReadonlyArray<{
                readonly urlLabel: string | null;
            } | null> | null;
        } | null> | null;
    };
};
export type userGeoInfoQuery = {
    readonly response: userGeoInfoQueryResponse;
    readonly variables: userGeoInfoQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "cookieDomain",
    "type": "String",
    "defaultValue": ""
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cookieDomain",
    "variableName": "cookieDomain"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "countryCode",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "zipCode",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "regionsByZipCode",
  "storageKey": null,
  "args": null,
  "concreteType": "RegionsByZipCode",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "urlLabel",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "userGeoInfoQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "regionalInfo",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "RegionalInfo",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "userGeoInfoQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "regionalInfo",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "RegionalInfo",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "userGeoInfoQuery",
    "id": "ferrum/257.0.0-2020-03-23T16:51:22.788Z/userGeoInfoQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'e32a7f893c7cff8886d857d5d83007dc';
export default node;
